
    <div class="alert-global__container">
      <alert
        *ngFor="let alert of alerts; let i = index"
        [dismissOnTimeout]="alert.timeout"
        (onClosed)="removeAlert($event, i)"
        [type]="alert.type"
        dismissable="false"
        class="alert--global"
      >
        <span [innerHtml]="alert.message"></span>
      </alert>
    </div>
    <div class="app-wrapper" #appWrapper data-iframe-height>
      <app-header *ngIf="showLoggedInComponents"></app-header>
      <router-outlet></router-outlet>
      <app-footer-desktop class="hidden-sm-down" *ngIf="showLoggedInComponents"></app-footer-desktop>
      <div class="app-tabs-spacer hidden-md-up"></div>
    </div>
    <app-footer-touch class="hidden-md-up" *ngIf="showLoggedInComponents"></app-footer-touch>
    <app-popovers></app-popovers>
    <!-- hide when logged out -->
    <app-tabs class="hidden-md-up" *ngIf="showLoggedInComponents"></app-tabs>
  